import * as Auth from '../services/Auth.Service';
import * as factory from '../services/Request.Factory';
let config = require('../base/URL.Config').config();

/**
 * Demo Function to get some info
 * @returns {JSON object} JSON object, each item is a post
 */
export function Search(search_term, category_id, genre_id, limit, offset) {
	let data = {
		search_term,
		category_id,
		genre_id,
		limit, 
		offset,
	};
	let base = config.URL.API.BASE;
	let url = base + config.URL.API.DASHBOARD.search;

	let request = new factory.Request();

	let response = request.Get('', url, data, 'AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw');
	return response;
}
/**
 * Get the info onf the requested faver
 * @returns {JSON object} JSON object, each item is a post
 */
export function Request(id) {
	let data = {
		faver_id: id
	};

	let base = config.URL.API.BASE;
	let url = base + config.URL.API.DASHBOARD.request;

	let request = new factory.Request();

	let response = request.Get('', url, data, 'AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw');
	return response;
}

/**
 * Get the info onf the requested faver
 * @returns {JSON object} JSON object, each item is a post
 */
export function SendFaver(faver) {
	delete faver.name
	let data = JSON.stringify(faver);
	
	//data.comment = faver.comment;

	let base = config.URL.API.BASE;
	let url = base + config.URL.API.DASHBOARD.faver;

	let request = new factory.Request();

	let response = request.Post('AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw', url, data);
	return response;
}


/**
 * Gets search results from the web
 * @returns {JSON object} JSON object, each item is a post
 */
 export function WebSearch(search) {
	let data = {
		search
	};
	let base = config.URL.API.BASE;
	let url = base + config.URL.API.DASHBOARD.web_search;
	let request = new factory.Request();
	let response = request.Get('', url, data, 'AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw');
	return response;
}

/**
 * Get the info onf the requested faver
 * @returns {JSON object} JSON object, each item is a post
 */
export function CreateItemFromUr(faver) {
  let data = JSON.stringify(faver);

  let base = config.URL.API.BASE;
  let url = base + config.URL.API.DASHBOARD.item_from_ur;

  let request = new factory.Request();

  let response = request.Post('AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw', url, data);
  return response;
}


// WEBPACK FOOTER //
// ./src/client/services/Dashboard.Service.js